<template>
  <div class="page-module-wrap">
    <!-- 搜索头部分 start -->
    <div class="search">
      <div class="tile is-parent">
        <article class="tile is-child box">
          <div class="section-gap">
            <div class="block">
              <div class="control">
                <label class="label inline-block r-top">日期：</label>
                  <el-date-picker
                    v-model="search.startTime"
                    type="date"
                    placeholder="选择日期"
                  >
                  </el-date-picker>
                  <span>~</span>
                  <el-date-picker
                    v-model="search.endTime"
                    type="date"
                    placeholder="选择日期"
                  >
                  </el-date-picker>
              </div>
              <button class="button is-primary width-2" @click="doSearch">查询</button>
            </div>
          </div>
        </article>
      </div>
    </div>
    <!-- 搜索头部分 end -->

    <!-- 列表部分 start -->
    <div class="list-wrap" ref="listWrap">
      <div class="scroll-x">
        <article class="box clearfix" :style="containerWidth">
            <table class="table is-bordered fleft" v-if="list.length">
              <thead>
                <tr>
                  <th></th>
                  <th :colspan="fields.length">汇总数据</th>
                  <th v-for="listItem in list" :colspan="fields.length">{{listItem.adminUsername}}</th>
                </tr>
                <tr>
                  <th></th>
                  <th v-for="fieldsItem in fields">{{fieldsItem.showName}}</th>
                  <template v-for="listItem in list">
                    <th v-for="fieldsItem in fields">{{fieldsItem.showName}}</th>
                  </template>
                </tr>
              </thead>
              <tbody>
                  <tr>
                    <td>汇总</td>
                    <td v-for="fieldsItem in fields">{{total.items[fieldsItem.fieldKey]}}</td>
                  </tr>
                  <tr v-for="(dateItem, index) in list[0].data">
                    <td>{{dateItem.date}}</td>
                    <td v-for="fieldsItem in fields"></td>
                    <template v-for="listItem in list">
                      <td v-for="fieldsItem in fields">{{listItem.data[index].items[fieldsItem.fieldKey]}}</td>
                    </template>
                  </tr>
              </tbody>
            </table>
            <span v-else class="data-isnull">暂无数据</span>
        </article>
      </div>
    </div>
  </div>
</template>
<script type="text/babel">
  import { getPreDate, getTimeByDateStr } from  'UTILS/date'

  export default {
    data(){
      return {
        count:0,
        search:{
          startTime:getPreDate(8),
          endTime:getPreDate(1)
        },
        fields:[],//标题
        list:[],//表数据
        total:[]//汇总
      }
    },
    mounted(){
      this.getList();
    },
    computed:{
      containerWidth(){
        let thW = 108,
          fieldsNum = this.fields.length,
          csNum = this.list.length+1,
          width = thW*fieldsNum*csNum+thW;
        if(!this.list.length || width < this.$refs.listWrap.offsetWidth){
          return {
            'width':"100%"
          };
        }
        return {
          'width':`${width}px`
        };
      }
    },
    methods:{
      doSearch(){
        this.getList();
      },
      getList(){
        let params = {
          startTime: getTimeByDateStr(this.search.startTime, "yyyy-MM-dd"),
          endTime: getTimeByDateStr(this.search.endTime, "yyyy-MM-dd")
        };
        HttpRequest.post('/admin.php?method=thirdparty.getCSStatistics',params).then(response => {
          this.fields = _.toArray(response.data.fields);
          this.list = _.toArray(response.data.list);
          this.total = response.data.total;
        })
      }
    }
  }
</script>
<style lang="less" scoped>
  .page-module-wrap {
    table {
      width:initial;
      th {
        text-align: center;
      }
      td {
        text-align:center;
        span {
          word-break: break-all;
        }
      }
    }
    p {
      word-break: break-all;
    }
  .clearfix:after {
    content: ".";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
  }
  .clearfix {
    _overflow: hidden;
  }
  .fleft{
    float: left;
  }
  .fright{
    float: right;
  }
  .red{
    color:red;
  }
  .green{
    color:green;
  }
  .margin-top {
    margin-top: 10px;
  }
  .margin-left {
    margin-left: 40px;
  }
  .width-2 {
    width: 150px;
  }
  .width-3 {
    width: 200px;
  input{
    width:180px;
  }
  }
  .inline-block {
    display: inline-block;
  }
  .vertical-middle {
    vertical-align: middle;
  }

  .title {
    font-size: 16px;
    height: 25px;
    line-height: 16px;
    padding-left: 6px;
    padding-right: 6px;
    font-weight: bold;
  }


  .control {
    display: inline-block;
    margin-right: 20px;
  }
  .margin-left1{
    margin-left: 20px;
  }
  .r-top {
    position: relative;
    top: 5px;
  }
  .danger{
    background-color: #ed6c63;
    border-color: transparent;
    color: white;
  }
  .list-wrap {
    padding-bottom: 40px;
    .order-item {
      margin-bottom: 30px;
      .img-goods {
        width:90%;
      }
    }
    .goods-img {
      min-width: 70px;
    }
  }
    .data-isnull {
      display: inline-block;
      width: 100%;
      font-size: 25px;
      color:#ccc;
      text-align: center;
    }
  }
  .scroll-x {
    overflow-x: scroll;
  }
</style>
